// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"19fb816c","732":"052a29ce","977":"4d3b58da"}[chunkId] + ".chunk.js");